import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { useNavigate } from 'react-router-dom'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import PopupBox from '../../components/popup/PopupBox'
import pencilicon from '../../assets/icons/pencil1.svg'
import archive from '../../assets/icons/archive.svg'
import rupeeIcon from '../../assets/icons/rupeeIcon.svg'
import '../course/viewCourseList.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import ModalUnstyled from '../../components/model/Model'
import { archiveFaculty, getFaculty } from '../../store/builders/faculty/faculty.builder'
import { capitalizeFirstLetter, dynamicCustomFilter } from '../../utility/genricFunction'
import HorizontalLine from '../../assets/icons/Line33.svg'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'

const Faculty = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [filteredData, setFilteredData] = useState([])
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [filterNumber] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [archiveId, setArchiveId] = useState('')


  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'userName': { value: null, matchMode: 'dynamic_custom' },
    'userPhone': { value: null, matchMode: 'dynamic_custom' },
    'userEmail': { value: null, matchMode: 'dynamic_custom' },
    'country.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'representative': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'status': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'verified': { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const { loading, facultyData } = useSelector((state) => state.faculty)

  useEffect(() => {
    dispatch(getFaculty())
    return () => dispatch({ type: 'faculty/clearExtraReducers' })
  }, [])
 
  useEffect(() => {
   facultyData && facultyData?.length && setFilteredData(facultyData)
  }, [facultyData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(facultyData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const [openArchive, setOpenArchive] = useState(false)
  const handleArchive = (facultyId) => {setOpenArchive(true)
    setIsOpen(true)
    setArchiveId(facultyId)
  }
  const handleFacultyArchive = (id) => {
    dispatch(archiveFaculty(id))
    setOpenArchive(false)
  }

  const verifiedBodyTemplate = (allFacultyData) => {
    const handleOnButtonClick = (id) => {
      const path = ROUTES_PATH.BILLING_INFO_ID.replace(':id', id)
      navigate(path)
    }
    const handleRowClick = (id) => {
      const path = ROUTES_PATH.FACULTY_EDIT.replace(':id', id)
      navigate(path)
    }
    return (
      <>
      <PopupBox rowData={allFacultyData} setIsOpen={setIsOpen} isOpen={isOpen}>
        <div className='popupbox'>
          <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

          <img src={HorizontalLine} alt='' />

          {UseAuthorization(permissions.BILLING_INFO) && (
            <button
              className='div-assign-to-branch'
              disabled={allFacultyData?.facultyStatus == 'archive' ? true : false}
              onClick={() => handleOnButtonClick(allFacultyData.facultyId)}
            >
              <img src={rupeeIcon} alt='' />
              <p
                className={`${allFacultyData?.facultyStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                {' '}
                Billing Info
              </p>
            </button>
          )}

          {UseAuthorization(permissions.ADD_FACULTY) && (
            <button
              className='div-assign-to-branch'
              disabled={allFacultyData?.facultyStatus == 'archive' ? true : false}
              onClick={() => handleRowClick(allFacultyData.facultyId)}
            >
              <img src={pencilicon} alt='' />
              <p
                className={`${allFacultyData?.facultyStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Edit
              </p>
            </button>
          )}

          {UseAuthorization(permissions.ARCHIVE_FACULTY) && (
            <button
              className='div-assign-to-branch'
              disabled={allFacultyData?.facultyStatus == 'archive' ? true : false}
              onClick={()=>handleArchive(allFacultyData.facultyId)}
            >
              <img src={archive} alt='' />
              <p
                className={`${allFacultyData?.facultyStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Archive
              </p>
            </button>
          )}
        </div>

      </PopupBox>
        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
            className={'archive-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => {
              handleFacultyArchive(archiveId)
            }}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )} 
        </>
    )
  }

  const verifiedRowFilterTemplate = (options) => {
    return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />
  }

  const nameBody = (facultyData) => {
    const representative = facultyData?.userName && capitalizeFirstLetter(facultyData?.userName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'userName',
      header: 'Faculty Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'userPhone',
      header: 'Phone',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by phone...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'userEmail',
      header: 'Email',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by email...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
      filterElement: verifiedRowFilterTemplate,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.FACULTY.LABEL_FACULTY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.FACULTY.LABEL_FACULTY,
      link: ROUTES_PATH.FACULTY,
    },
  ]

  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            {UseAuthorization(permissions.ADD_FACULTY) && <Button className='add-btn' onClick={() => navigate('/faculty/add-faculty')}>
              Add Faculty
            </Button>}
          </div>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>{UI_CONSTANT.FACULTY.ALL_FACULTY}</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          <div className='table-card action-btn-include'>
            {/* {facultyData?.length && ( */}
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                // rows={selectedNumber}
                filters={filters}
                // loading={loading}
                // globalFilterFields={['name', 'country.name', 'representative.name', 'status']}
                columns={columns}
                archiveKey={'facultyStatus'}
                onFilter={onFilter}
              />
            {/* )} */}
          </div>
        </div>

        {/* <BranchTable /> */}
        {/* </div> */}
      </div>}
    </>
  )
}

export default Faculty
